import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { API } from '@service';
import { Loading } from '@components';
import {
  PDFDownload,
  PDFTitle,
} from '@components/hubModule/pdfTitleAndDownload';
import { injectPDFStyleOnIframeLoad } from '@utils/common';
import { handleNameInitialsModuleBack } from '@utils/history';

function IntegrationIframePage() {
  const [pdfContent, setPdfContent] = useState(null);
  const history = useHistory();
  const location = useLocation();
  const isInternal = JSON.parse(
    window.localStorage.userInfo || '{}',
  ).isInternal;
  useEffect(() => {
    (async () => {
      const isPowerBIGuide = location.search.includes('type=powerbi');

      let requestApi = () => {
        const type = isInternal ? 'Internal' : 'Client';
        return API.getUserGuideRequest(type);
      };

      if (isPowerBIGuide) {
        requestApi = () => API.getUserGuideRequest('share');
      }
      const { fileName, data } = await requestApi();

      setPdfContent({ contentBlob: data, fileName });
    })();

    return () => {
      URL.revokeObjectURL(pdfContent);
    };
  }, []);
  return (
    <div className="page-wrapper integration-iframe-page project">
      <span
        className="dd-back-btn"
        onClick={() => handleNameInitialsModuleBack(history)}
      >
        <span className="appkiticon icon-left-chevron-fill a-font-12" /> Back
      </span>
      <div
        className="project-form-title"
        style={{ marginTop: '1.5rem', marginBottom: '2rem' }}
      >
        User Guide
      </div>

      <div
        className="guide-wrapper"
        id="iframe-pdf-container"
        style={{ position: 'relative' }}
      >
        {pdfContent ? (
          <>
            <PDFTitle pdfContent={pdfContent} zoomed />
            <PDFDownload pdfContent={pdfContent} zoomed />
            <iframe
              style={{ paddingTop: '1.875rem !important' }}
              title="inte-iframe"
              src={`${URL.createObjectURL(pdfContent.contentBlob)}`}
              onLoad={injectPDFStyleOnIframeLoad}
            />
          </>
        ) : (
          <Loading style={{ textAlign: 'center', marginTop: '10%' }} />
        )}
      </div>
    </div>
  );
}

export default React.memo(IntegrationIframePage);
